import React from 'react';
import UniversalAuthPage from '../../../components/Auth/UniversalAuthPage';

const AirlinerLoginPage = () => {
  const handleLogin = async (formData) => {
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 2000));
    
    // Simulate login success
    alert('Airliner login successful!');
    // Navigation is handled by UniversalAuthPage
  };

  return (
    <UniversalAuthPage
      type="login"
      appType="airliner"
      title="Airliner Login"
      subtitle="Access your airliner management panel"
      onSubmit={handleLogin}
      redirectPaths={{
        success: '/airliner'
      }}
    />
  );
};

export default AirlinerLoginPage;